// extracted by mini-css-extract-plugin
export var base = "ContentHeader-module--base--b9e02";
export var borderBottom = "ContentHeader-module--border-bottom--2b0f1";
export var borderTop = "ContentHeader-module--border-top--65e29";